import { BaseModel, Column, Model } from 'scf-graphql-model'

@Model('publisher', ['publishers'])
export class Publisher extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  name: string | undefined;
  @Column()
  url: string | undefined;
}
